import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { SupplierPortalService } from '../../../core/services/supplier-portal/supplier-portal.service'
import { TableListSupplierPortalOsComponent } from '../../../shared/components/table-list-supplier-portal-os/table-list-supplier-portal-os.component'

@Component({
  selector: 'supplier-portal-os-list',
  standalone: true,
  imports: [MatCard, MatProgressBar, MatPaginatorModule, TableListSupplierPortalOsComponent],
  templateUrl: './supplier-portal-os-list.component.html',
  styleUrl: './supplier-portal-os-list.component.scss',
})
export class SupplierPortalOsListComponent implements OnInit {
  constructor(
    private supplierPortalService: SupplierPortalService,
    private router: Router,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false

  columns: any[] = [
    { keyColumn: 'ordemServicoId', key: 'ordemServicoId', description: 'OS' },
    { keyColumn: 'status', key: '', description: 'Status' },
    { keyColumn: 'periodo', key: '', description: 'Período' },
    { keyColumn: 'origemDestino', key: '', description: 'Origem/Destino' },
    { keyColumn: 'valorTotal', key: '', description: 'Valor' },
    { keyColumn: 'prazoPagamento', key: '', description: 'Prazo de Pagamento' },
    { keyColumn: 'atribuicoes', key: '', description: '' },
    { keyColumn: 'nomeConsultorOperacional', key: 'nomeConsultorOperacional', description: 'Consultor' },
    { keyColumn: 'obsFornecedor', key: '', description: 'Observação' },
    { keyColumn: 'action', key: { view: true }, description: 'Ações' },
  ]

  ngOnInit() {
    this.getListItems()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.getListItems()
  }

  treatResponse(response: any) {
    // lista vazia volta como 206 com data null
    this.itemsList = response.data ?? []
    this.numberRows = response.totalItens ?? 0
  }

  getListItems() {
    this.loading = true
    this.supplierPortalService.listPagedOs(this.page, this.rows).subscribe({
      next: (response: any) => { this.treatResponse(response) },
      error: () => { this.loading = false },
      complete: () => { this.loading = false },
    })
  }

  viewItem(item: any) {
    this.router.navigate(['/portal-fornecedor', item.ordemServicoId])
  }
}
